// Mock data for BuyerBeacon Pro (BBP) — a data-intelligence platform for small business
// All content is mocked. Replace with real backend data later.

export const brand = {
  name: "BuyerBeacon",
  suffix: "Pro",
  tagline: "Find ready buyers in a sea of noise.",
  affiliateOf: "BuyerBeacon Pro",
};

// "Beacon Network" stats strip — original wording, not borrowed
export const stats = [
  { value: "280M+", label: "Profiles Illuminated" },
  { value: "120M+", label: "Verified Buyer Signals" },
  { value: "60K+", label: "Intent Categories Scanned" },
  { value: "<2 min", label: "Avg. Time to First Match" },
];

// Pulse ticker — fake-but-believable live event feed
export const pulseEvents = [
  "Ready buyer surfaced in Healthcare",
  "High-intent visitor identified — SaaS, $25M+",
  "Beacon Score 92 triggered in Real Estate",
  "Direct-mail audience built in 38 sec",
  "B2B contact resolved — VP Marketing",
  "Lookalike refreshed — 12,408 new matches",
  "Intent spike detected in Financial Services",
  "Beacon Score 88 triggered in E-commerce",
];

export const features = [
  {
    slug: "website-visitor-id",
    icon: "Eye",
    title: "Website Visitor ID",
    desc: "Unmask anonymous traffic. Get names, emails, and firmographics — no forms needed.",
    metric: "70%",
    metricLabel: "match rate",
    tag: null,
  },
  {
    slug: "consumer-data",
    icon: "Users",
    title: "Consumer Data",
    desc: "280M+ US adults with 400+ demographic, behavioral, and intent attributes.",
    metric: "280M+",
    metricLabel: "profiles",
    tag: null,
  },
  {
    slug: "business-intelligence",
    icon: "Building2",
    title: "Business Intelligence",
    desc: "120M+ verified B2B contacts with firmographics, technographics, and org charts.",
    metric: "120M+",
    metricLabel: "contacts",
    tag: null,
  },
  {
    slug: "audience-builder",
    icon: "Target",
    title: "Audience Builder",
    desc: "Build hyper-targeted audiences from any attribute. Export to any platform.",
    metric: "60K+",
    metricLabel: "segments",
    tag: null,
  },
  {
    slug: "offline-activation",
    icon: "Mail",
    title: "Offline Activation",
    desc: "Trigger postcards, letters, and printed media from digital intent signals.",
    metric: "48hr",
    metricLabel: "delivery",
    tag: null,
  },
  {
    slug: "pulse",
    icon: "Zap",
    title: "Beacon Pulse",
    desc: "Real-time CRM enrichment with live intent signals and buying triggers.",
    metric: "Live",
    metricLabel: "signals",
    tag: "New",
  },
  {
    slug: "buyer-intent",
    icon: "Activity",
    title: "Buyer Intent",
    desc: "40K+ intent categories with daily signal refresh. Know who's in-market first.",
    metric: "40K+",
    metricLabel: "categories",
    tag: null,
  },
  {
    slug: "authorized-partner",
    icon: "ShieldCheck",
    title: "Authorized Partner",
    desc: "White-label our entire data platform under your brand. 80%+ margins from day one.",
    metric: "80%+",
    metricLabel: "margins",
    tag: null,
  },
];

export const audiences = [
  {
    name: "Q2 Retargeting — SaaS",
    filters: [
      { k: "Industry", v: "SaaS" },
      { k: "Revenue", v: "$10M+" },
      { k: "Intent", v: "High" },
    ],
    beaconScore: 92,
    records: "18,432",
  },
  {
    name: "Enterprise Decision Makers",
    filters: [
      { k: "Title", v: "VP+" },
      { k: "Employees", v: "500+" },
      { k: "Tech Stack", v: "Salesforce" },
    ],
    beaconScore: 88,
    records: "7,891",
  },
  {
    name: "Pricing-Page Visitors",
    filters: [
      { k: "Page", v: "/pricing" },
      { k: "Visits", v: "3+" },
      { k: "Last 30 days", v: "" },
    ],
    beaconScore: 81,
    records: "3,204",
  },
  {
    name: "Lookalike — Top Customers",
    filters: [
      { k: "Match", v: "95%+" },
      { k: "Region", v: "US" },
      { k: "B2B Only", v: "" },
    ],
    beaconScore: 76,
    records: "42,670",
  },
  {
    name: "Direct Mail — Homeowners",
    filters: [
      { k: "Homeowner", v: "Yes" },
      { k: "Income", v: "$100K+" },
      { k: "Age", v: "30-55" },
    ],
    beaconScore: 69,
    records: "126,340",
  },
];

export const integrations = [
  { name: "Google Ads", initials: "GA", color: "#4285F4" },
  { name: "Meta", initials: "M", color: "#0866FF" },
  { name: "Salesforce", initials: "SF", color: "#00A1E0" },
  { name: "HubSpot", initials: "HS", color: "#FF7A59" },
  { name: "Shopify", initials: "S", color: "#95BF47" },
  { name: "Go High Level", initials: "GHL", color: "#1F2937" },
  { name: "Klaviyo", initials: "K", color: "#000000" },
  { name: "Snowflake", initials: "SN", color: "#29B5E8" },
  { name: "Mailchimp", initials: "MC", color: "#FFE01B" },
  { name: "Zapier", initials: "Z", color: "#FF4A00" },
  { name: "Segment", initials: "SG", color: "#52BD94" },
  { name: "TikTok Ads", initials: "TT", color: "#FE2C55" },
];

export const industries = [
  { name: "SaaS & Tech", icon: "Cpu" },
  { name: "Financial Services", icon: "Landmark" },
  { name: "Healthcare", icon: "HeartPulse" },
  { name: "Real Estate", icon: "Home" },
  { name: "E-commerce", icon: "ShoppingBag" },
  { name: "Insurance", icon: "Shield" },
  { name: "Automotive", icon: "Car" },
  { name: "Education", icon: "GraduationCap" },
  { name: "Agencies", icon: "Briefcase" },
];

export const navLinks = [
  {
    label: "Platform",
    children: [
      { label: "Website Visitor ID", desc: "Unmask anonymous traffic", to: "/solutions/website-visitor-id" },
      { label: "Audience Builder", desc: "Build hyper-targeted lists", to: "/solutions/audience-builder" },
      { label: "Offline Activation", desc: "Direct mail from digital signals", to: "/solutions/offline-activation" },
      { label: "Beacon Pulse", desc: "Real-time CRM enrichment", to: "/solutions/pulse" },
      { label: "Buyer Intent", desc: "40K+ buying signals", to: "/solutions/buyer-intent" },
    ],
  },
  {
    label: "Data",
    children: [
      { label: "Consumer Data", desc: "280M+ US adult profiles", to: "/solutions/consumer-data" },
      { label: "Business Intelligence", desc: "120M+ B2B contacts", to: "/solutions/business-intelligence" },
      { label: "Authorized Partner", desc: "White-label our platform", to: "/solutions/authorized-partner" },
    ],
  },
  {
    label: "Industries",
    children: [
      { label: "Roofing", to: "/industries/roofing" },
      { label: "Windows & Doors", to: "/industries/windows" },
      { label: "Landscaping", to: "/industries/landscaping" },
      { label: "Home Renovation", to: "/industries/home-renovation" },
      { label: "Dispensary", to: "/industries/dispensary" },
      { label: "HVAC", to: "/industries/hvac" },
      { label: "Plumbing", to: "/industries/plumbing" },
      { label: "Catering", to: "/industries/catering" },
      { label: "Car Dealership", to: "/industries/car-dealership" },
      { label: "Wedding Venue", to: "/industries/wedding-venue" },
      { label: "Auto Repair", to: "/industries/auto-repair" },
      { label: "Agencies", to: "/industries/agencies" },
    ],
  },
  { label: "Pricing", to: "/pricing" },
  { label: "Resources", to: "/resources" },
  { label: "About", to: "/about" },
  { label: "Affiliate", to: "/affiliate" },
];

export const testimonials = [
  {
    quote:
      "BuyerBeacon Pro showed us 24,000 corporate-giving prospects we would never have found on our own. Our match-grant pipeline doubled in a single quarter.",
    name: "Renée Okafor",
    title: "Director of Partnerships, World Food Bank",
    initials: "RO",
  },
  {
    quote:
      "We expanded outbound into fourteen new verticals by modeling lookalikes off our closed-won list. The Beacon Score made prioritization obvious.",
    name: "Daniel Vogt",
    title: "Head of Growth, eSkrybe",
    initials: "DV",
  },
  {
    quote:
      "Anonymous visitors used to be a black hole. Now we turn pricing-page traffic into tasting bookings — last month, forty-seven of them.",
    name: "Marisol Tan",
    title: "Marketing Lead, Serendipity Catering",
    initials: "MT",
  },
];

// Industry Signal Stories — original case studies tied to our trusted-by brands
export const signalStories = [
  {
    industry: "Nonprofit",
    brand: "World Food Bank",
    headline: "24,180 corporate-giving prospects identified in six weeks",
    metric: "+2.3x",
    metricLabel: "match-grant conversion",
    color: "#d4af37",
  },
  {
    industry: "B2B SaaS",
    brand: "eSkrybe",
    headline: "Outbound expanded to 14 new verticals using lookalike modeling",
    metric: "14",
    metricLabel: "new verticals opened",
    color: "#d4af37",
  },
  {
    industry: "Hospitality",
    brand: "Serendipity Catering",
    headline: "312 anonymous pricing-page visitors became 47 booked tastings",
    metric: "15%",
    metricLabel: "visitor-to-booking rate",
    color: "#d4af37",
  },
  {
    industry: "Home Services",
    brand: "Garden Hero",
    headline: "89K homeowner-intent signals powered a regional direct-mail launch",
    metric: "7.8%",
    metricLabel: "direct-mail response",
    color: "#d4af37",
  },
  {
    industry: "Media",
    brand: "Times Future",
    headline: "60K newsletter subscribers enriched with B2B firmographics",
    metric: "+41%",
    metricLabel: "sponsored placement RPM",
    color: "#d4af37",
  },
  {
    industry: "Financial Services",
    brand: "Trade Oracle Group",
    headline: "Real-time alerts on Tier-1 acquisition signals shortened the sale",
    metric: "-38%",
    metricLabel: "average sales cycle",
    color: "#d4af37",
  },
];

// Trusted-by partner logos
export const trustedBy = [
  {
    name: "World Food Bank",
    kind: "image",
    src: "https://customer-assets.emergentagent.com/job_conversion-lab-55/artifacts/x59wrca3_wfb-logo-blue.jpg",
    tone: "light",
  },
  {
    name: "eSkrybe",
    kind: "image",
    src: "https://customer-assets.emergentagent.com/job_conversion-lab-55/artifacts/l1776oyb_eskrybe_logo_final.png",
    tone: "cream",
  },
  {
    name: "Serendipity Catering",
    kind: "wordmark-serif",
    tone: "light",
  },
  {
    name: "Garden Hero",
    kind: "wordmark-sans",
    tone: "light",
  },
  {
    name: "Times Future",
    kind: "timesfuture",
    tone: "cream",
  },
  {
    name: "Trade Oracle Group",
    kind: "image",
    src: "https://customer-assets.emergentagent.com/job_conversion-lab-55/artifacts/ry6wo39i_NO%20BKGRND%20TOG%20LOGO.png",
    tone: "dark",
  },
];

// Three-step "How Beacons Work" — Identify > Connect > Close
export const howItWorks = [
  {
    step: "01",
    title: "Identify",
    icon: "Radar",
    desc: "Scan 280M+ profiles and 120M+ verified buyer signals. Resolve anonymous visitors, surface in-market accounts, and rank everything by Beacon Score.",
    points: ["Visitor unmasking", "Intent monitoring", "Beacon Score ranking"],
  },
  {
    step: "02",
    title: "Connect",
    icon: "Plug",
    desc: "Push enriched audiences directly into the channels you already use — ads, CRM, email, and direct mail — without a single CSV export.",
    points: ["200+ native integrations", "Real-time sync", "API & webhooks"],
  },
  {
    step: "03",
    title: "Close",
    icon: "Trophy",
    desc: "Activate multi-channel plays the moment a buyer is ready. Track outcomes, refresh signals daily, and feed wins back into your beacons.",
    points: ["Cross-channel orchestration", "Outcome attribution", "Continuous signal refresh"],
  },
];

export const faqs = [
  {
    q: "What is BuyerBeacon Pro?",
    a: "BuyerBeacon Pro is a buyer-intelligence platform built for small business. We help teams cut through marketing noise and surface the buyers who are actually ready — across 280M+ profiles and 120M+ verified buyer signals.",
  },
  {
    q: "How is BuyerBeacon Pro different from other data platforms?",
    a: "We pool the cost of sourcing, qualifying, and cleaning intent data across our customer base — so small businesses pay a fraction of what enterprise teams pay for the same signal. You get white-glove onboarding, custom Beacon Score thresholds tuned to your ICP, and a single point of accountability for your account.",
  },
  {
    q: "What is a Beacon Score?",
    a: "Beacon Score is a 0–100 buyer-readiness rating assigned to every contact, company, or visitor in your audiences. Scores combine intent signals, firmographic fit, and recency — so your team always knows who to call first.",
  },
  {
    q: "How does visitor identification work?",
    a: "A lightweight pixel resolves anonymous web traffic against our identity graph. You receive verified names, business emails, and firmographics — no forms required, no friction added to your site.",
  },
  {
    q: "Can I integrate with my existing stack?",
    a: "Yes. 200+ native integrations including Salesforce, HubSpot, Go High Level, Klaviyo, and more — plus full API and webhook access for anything custom.",
  },
  {
    q: "Is the platform compliant?",
    a: "SOC 2 Type II certified. GDPR and CCPA compliant. Every dataset is licensed, audited, and refreshed under strict data-hygiene practices.",
  },
];

export const footerLinks = {
  Platform: [
    { label: "Website Visitor ID", to: "/solutions/website-visitor-id" },
    { label: "Audience Builder", to: "/solutions/audience-builder" },
    { label: "Buyer Intent", to: "/buyer-intent" },
    { label: "Beacon Pulse", to: "/solutions/pulse" },
    { label: "Integrations", to: "/integrations" },
  ],
  Data: [
    { label: "Consumer Data", to: "/solutions/consumer-data" },
    { label: "Business Intelligence", to: "/solutions/business-intelligence" },
    { label: "Offline Activation", to: "/solutions/offline-activation" },
  ],
  Company: [
    { label: "About", to: "/about" },
    { label: "Pricing", to: "/pricing" },
    { label: "Affiliate Program", to: "/affiliate" },
    { label: "Get a Demo", to: "/demo" },
    { label: "Resources", to: "/resources" },
  ],
  Legal: [
    { label: "Privacy", to: "/privacy" },
    { label: "Terms", to: "/terms" },
    { label: "Security", to: "/security" },
    { label: "Compliance", to: "/compliance" },
    { label: "Opt Out", to: "/optout" },
  ],
};
